//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    icon: {
      type: String,
      default: 'empty-universe',
    },
    emptyText: {
      type: String,
      default: '这位用户还没有上传资源~',
    },
    emptyTitle: {
      type: String,
    },
    hadXss: { // 字符串做过 防Xss攻击
      type: Boolean,
      default: false,
    },
  },
};
